
import * as awsAmplifyRuntime$_45MGhADe7BwolKDjMzEJQMtGM3Db1rVRHQ0P_SeZ0LJE from '/codebuild/output/src553298470/src/compass-v2/node_modules/@nuxt/image/dist/runtime/providers/awsAmplify'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "awsAmplify",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp",
    "jpeg",
    "png",
    "webp"
  ],
  "quality": 75
}

imageOptions.providers = {
  ['awsAmplify']: { provider: awsAmplifyRuntime$_45MGhADe7BwolKDjMzEJQMtGM3Db1rVRHQ0P_SeZ0LJE, defaults: {} }
}
        